export const downloadFile = (href: string, filename: string = '') => {
  const element = document.createElement('a');

  element.setAttribute('href', href);
  element.setAttribute('download', filename);
  element.click();
};
